export const minusIconTestId = 'minusIconTestId';
export const plusIconTestId = 'plusIconTestId';
